import { render } from "./TheProfessionalResourcesShowModal.vue?vue&type=template&id=23da8c40&ts=true"
import script from "./TheProfessionalResourcesShowModal.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalResourcesShowModal.vue?vue&type=script&lang=ts"

import "./TheProfessionalResourcesShowModal.vue?vue&type=style&index=0&id=23da8c40&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__